'use es6';

import { useContext } from 'react';
import isLegacyHubSpotObject from 'customer-data-objects/crmObject/isLegacyHubSpotObject';
import CrmObjectActionsDropdown from './CrmObjectActionsDropdown';
import { PermissionsContext } from '../context/PermissionsContext';
import { SidebarSubjectContext } from '../context/SidebarSubjectContext';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/transitional/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalSidebarHighlight = ({
  objectId,
  objectType
}) => {
  const {
    canDeleteSubject,
    readOnly
  } = useContext(PermissionsContext);
  const {
    primaryDisplayLabel
  } = useContext(SidebarSubjectContext);
  const isCrmObject = !isLegacyHubSpotObject(objectType);
  const renderActions = () => {
    if (isCrmObject && canDeleteSubject && !readOnly) {
      return /*#__PURE__*/_jsx(CrmObjectActionsDropdown, {
        objectTypeId: objectType,
        objectId: objectId
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(View, {
    borderBlockEndWidth: "100",
    borderBlockEndColor: "border-core-default",
    borderBlockEndStyle: "solid",
    padding: "600",
    "data-selenium-test": "universal-sidebar-highlight",
    "data-test-id": "universal-sidebar-highlight",
    children: [renderActions(), /*#__PURE__*/_jsx(H2, {
      textAlign: "left",
      paddingBlock: "100",
      paddingInline: "400",
      marginBlockEnd: "100",
      children: primaryDisplayLabel
    })]
  });
};
UniversalSidebarHighlight.propTypes = {
  objectId: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired
};
export default UniversalSidebarHighlight;